import React from 'react';
import './Testimonial.css';
import { Swiper, SwiperSlide } from 'swiper/react'
import ProfilePic1 from "../../img/profile1.jpeg";
import ProfilePic2 from "../../img/profile2.jpg";
import ProfilePic3 from "../../img/profile3.jpeg";
import ProfilePic4 from "../../img/profile4.jpeg";
import ProfilePic5 from "../../img/profile5.jpg";
import { Pagination } from "swiper";
import 'swiper/css/pagination';
import 'swiper/css'
const Testimonial = () => {
    const clients = [
        {
            img: ProfilePic1,
            review:
                `Hey you are very good . Your Potential is ultimate. If anyone seach 
                a good developer of React based project build contact this guy .He is very ultimate
                persone .Five rating on my side`,
        },
        {
            img: ProfilePic2,
            review:  `who want to speed up their software delivery 
            and unlock the full potential of cloud adoption and development.Meet this freelancer guy its work 
            is very awesome and cook .On time delicery`,
        },
        {
            img: ProfilePic3,
            review: `This guy ,develop a flexible marketplace platform
            . Working with the internal team, the vendor makes critical design and technology decisions.
            awesome work to this person and project.`,
        },
        {
            img: ProfilePic4,
            review: `He helped the client build the platform and launch it across various
             markets.the client has grown their revenue by 400%. The client
            appreciates the team's modern workflow and project management.`
        },
        {
            img: ProfilePic5,
            review: `Very dedicater person about to client's services. Very nice job.
            Thank you so much sir , I am from calcatt and I am fortunate who is work with you 
            Such a amazing experiene guys ,He is very knowledge`
        }
    ]
    return (
        <div className="t-wrapper" id='Testimonial'>
            <div className="t-heading">
                <span>Friends always get </span>
                <span>Exceptional Work </span>
                <span>from me....</span>
                <div className="blur t-blur1" style={{ background: "var(--purple)" }}></div>
                <div className="blur t-blur2" style={{ background: "var(--skyblue)" }}></div>
            </div>
            {/* Slide */}
            <Swiper
                modules={[Pagination]}
                slidesPerView={1}
                pagination={{ clickable: true }}
            >
                {clients.map((client, index) => {
                    return (
                        <SwiperSlide key={index}>
                            <div className="testimonial">
                                <img src={client.img} alt="" />
                                <span>{client.review}</span>
                            </div>
                        </SwiperSlide>
                    );
                })}
            </Swiper>
        </div>
    );
};

export default Testimonial
